import { css } from 'styled-components'

export const desktopMenuItemStyles = css`
  color: ${(props) => props.theme.textColor};
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  margin-bottom: 20px;
`
